// @flow strict
import { useStaticQuery, graphql } from "gatsby"

const useAllMdx = () => {
  const { allMdx } = useStaticQuery(
    graphql`
      query AllMdx {
        allMdx {
          nodes {
            fields {
              slug
            }
            frontmatter {
              title
              description
              thumbnail {
                childImageSharp {
                  gatsbyImageData
                }
              }
              asin
              brand
              year
              name
              rakuten
            }
          }
        }
      }
    `
  )

  return allMdx
}

export default useAllMdx
